'use client'
import * as React from 'react'
import { Icon, type IconProps } from '../Icon'
const CrossHexagonFillIcon = React.forwardRef((props: IconProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      viewBox="0 0 24 24"
      ref={ref}
      {...props}
    >
      <path d="M4 9.06066V15.45L8.57143 20.25H15.9286L20.5 15.45V9.06066L15.4393 4H9.06066L4 9.06066ZM8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967L12.25 11.1893L15.2197 8.21967C15.5126 7.92678 15.9874 7.92678 16.2803 8.21967C16.5732 8.51256 16.5732 8.98744 16.2803 9.28033L13.3107 12.25L16.2803 15.2197C16.5732 15.5126 16.5732 15.9874 16.2803 16.2803C15.9874 16.5732 15.5126 16.5732 15.2197 16.2803L12.25 13.3107L9.28033 16.2803C8.98744 16.5732 8.51256 16.5732 8.21967 16.2803C7.92678 15.9874 7.92678 15.5126 8.21967 15.2197L11.1893 12.25L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967Z" />
      <path d="M8.95711 2.5C8.62559 2.5 8.30764 2.6317 8.07322 2.86612L2.86612 8.07322C2.6317 8.30764 2.5 8.62559 2.5 8.95711V15.55C2.5 15.871 2.62347 16.1796 2.84483 16.4121L7.55911 21.3621C7.79504 21.6098 8.12219 21.75 8.46429 21.75H16.0357C16.3778 21.75 16.705 21.6098 16.9409 21.3621L21.6552 16.4121C21.8765 16.1796 22 15.871 22 15.55V8.95711C22 8.62559 21.8683 8.30764 21.6339 8.07322L16.4268 2.86612C16.1924 2.6317 15.8744 2.5 15.5429 2.5H8.95711ZM4 9.06066L9.06066 4H15.4393L20.5 9.06066V15.45L15.9286 20.25H8.57143L4 15.45V9.06066Z" />
    </Icon>
  )
})
export { CrossHexagonFillIcon }
